import { useState, useCallback } from 'react';
import { Form, message } from 'antd';
import { useNavigate } from 'react-router';
import { useCommonStore } from '@/store/useCommonStore';

/**
 * 登录表单自定义Hook
 * 封装登录相关的状态管理和业务逻辑
 */
export const useLoginForm = () => {
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('account');
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const login = useCommonStore.use.login();

  // 切换登录方式
  const handleTabChange = useCallback((key) => {
    form.resetFields();
    setActiveTab(key);
  }, [form]);

  // 处理登录逻辑
  const handleLogin = useCallback(async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      if (activeTab === "account") {
        const result = await login(values.uid, values.pwd);
        if (result.success) {
          navigate("/");
        } else {
          message.error(result.message || '登录失败，请检查账号密码');
        }
      }
      console.log('登录信息:', values);
    } catch (err) {
      console.log('表单验证失败:', err);
    } finally {
      setLoading(false);
    }
  }, [form, activeTab, login, navigate]);

  return {
    loading,
    activeTab,
    form,
    handleTabChange,
    handleLogin
  };
};